import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import { StaticQuery } from "gatsby";
import Image from "gatsby-image";
var GalleryImage = function GalleryImage(props) {
    var _props$data, _props$data$unsplash, _props$data$unsplash$, _props$data$unsplash$2, _props$data$unsplash$3;
    return /*#__PURE__*/ React.createElement("section", {
        className: "gallery"
    }, /*#__PURE__*/ React.createElement(Image, {
        fluid: Object.assign({}, props.image || ((_props$data = props.data) === null || _props$data === void 0 ? void 0 : (_props$data$unsplash = _props$data.unsplash) === null || _props$data$unsplash === void 0 ? void 0 : (_props$data$unsplash$ = _props$data$unsplash.edges) === null || _props$data$unsplash$ === void 0 ? void 0 : (_props$data$unsplash$2 = _props$data$unsplash$.find(function (e) {
            return e.node.name === (props.unsplashImageName || "main");
        })) === null || _props$data$unsplash$2 === void 0 ? void 0 : (_props$data$unsplash$3 = _props$data$unsplash$2.node.childImageSharp) === null || _props$data$unsplash$3 === void 0 ? void 0 : _props$data$unsplash$3.fluid))
    }));
};
var ConnectedGalleryImage = /*#__PURE__*/ function (_React$Component) {
    _inheritsLoose(ConnectedGalleryImage, _React$Component);
    function ConnectedGalleryImage() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ConnectedGalleryImage.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ React.createElement(StaticQuery, {
            query: "322315813",
            render: function render(data) {
                return /*#__PURE__*/ React.createElement(GalleryImage, Object.assign({
                    data: data
                }, _this.props));
            }
        });
    };
    return ConnectedGalleryImage;
}(React.Component);
export { ConnectedGalleryImage as default };
